import { toast } from "react-toastify";
import { decryptToken, getToken } from "../utilities/Constants";

const url = `${process.env.REACT_APP_API_URL}user/me`;

export const updateData = async (
  api,
  data,
  params,
  post,
  login,
  navigate,
  put
) => {
  const requestOptions = {
    method: post ? "POST" : put ? "PUT" : "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken(),
    },
    body: data ? JSON.stringify(data) : "",
  };

  const response = await fetch(
    params
      ? `${process.env.REACT_APP_API_URL}${api}/${params}`
      : `${process.env.REACT_APP_API_URL}${api}`,
    requestOptions
  )
    .then(async (response) => {
      const isJson = response.headers
        .get("content-type")
        ?.includes("application/json");
      const data = isJson && (await response.json());
      let success = "";

      // check for error response
      if (!response.ok) {
        // get error message from body or default to response status
        const error = data.error;
        return Promise.reject(error);
      } else {
        success = data?.message ? data.message : "Success";
        toast.success(success, {
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        if (login) {
          fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + decryptToken(data?.data?.token),
            },
          })
            .then((res) => res.json())
            .then((dat) => {
              if (dat?.data?.status === "active") {
                // Save token to session: (key, value)
                sessionStorage.setItem(
                  "ebc202c5c66c906f41dfee622fb64242",
                  data.data.token
                );
                navigate("/");
              } else {
                sessionStorage.clear();
                errorToast(
                  "Your account is inactive, please contact the administration"
                );
              }
            })
            .catch((err) => console.log(err));
        }
        return success;
      }
    })
    .catch((error) => {
      errorToast(error || "Something went wrong!");
    });

  return response;
};

function errorToast(errorMsg) {
  toast.error(errorMsg, {
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
}
